<script>
import api from '@/command/api'
import FormDropDownInput from '../FormDropDownInput'
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Object,
      default: () => {}
    },
    setValue: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      typeData: []
    }
  },
  methods: {
    async onInputSearch(value) {
      let searchResult = await api.command.search.call(this, {
        url: this.item.url + `&name=${value}`
      })
      this.typeData = searchResult.map(el => {
        return {
          name: el.name,
          value: el.id
        }
      })
    },
    onMenuClick(select) {
      this.setValue(this.item.valueKey, select.value)
    }
  },
  render() {
    return (
      <FormDropDownInput
        typeData={this.typeData}
        item={{
          ...this.item,
          inputProps: {},
          onInputSearch: this.onInputSearch,
          onMenuClick: this.onMenuClick
        }}
        value={this.value}
        onChange={value => this.$emit('change', value)}
      />
    )
  }
}
</script>
